  // Initialize Swiper for complementary products if the container exists
(function initComplementaryProductsSwiper() {
  const swiperContainer = document.querySelector('.complementary-products-container swiper-container');
  if (!swiperContainer) return;

  const handleSwiperState = (shouldEnable) => {
    if (shouldEnable) {
      swiperContainer.setAttribute('init', 'true');
      swiperContainer.classList.remove('desktop');

      if (swiperContainer.swiper && swiperContainer.swiper.destroyed) {
        swiperContainer.initialize();
      } else if (!swiperContainer.swiper && typeof swiperContainer.initialize === 'function') {
        swiperContainer.initialize();
      }
      return;
    }

    if (swiperContainer.swiper && !swiperContainer.swiper.destroyed) {
      swiperContainer.swiper.destroy(true, true);
    }
    swiperContainer.setAttribute('init', 'false');
    swiperContainer.classList.add('desktop');
  };

  const applyInitialState = () => {
    const isMobile = window.innerWidth <= 767;
    handleSwiperState(isMobile);
  };

  applyInitialState();

  let resizeTimeout;
  const handleResize = () => {
    if (resizeTimeout) {
      clearTimeout(resizeTimeout);
    }
    resizeTimeout = setTimeout(applyInitialState, 100);
  };

  window.addEventListener('resize', handleResize);
})();
